var CookieConsent;
(function(CookieConsent) {
    CookieConsent[CookieConsent["Unknown"] = 0] = "Unknown";
    CookieConsent[CookieConsent["Disabled"] = 1] = "Disabled";
    CookieConsent[CookieConsent["Requested"] = 2] = "Requested";
    CookieConsent[CookieConsent["Enabled"] = 3] = "Enabled";
})(CookieConsent || (CookieConsent = {}));
var checkConsent = function() {
    try {
        var ucUserInteraction = window.localStorage.getItem("uc_user_interaction");
        if (ucUserInteraction === "true") {
            return CookieConsent.Enabled;
        }
        if (ucUserInteraction === null) {
            return CookieConsent.Requested;
        }
        return CookieConsent.Disabled;
    } catch (err) {
        // Catch `Usercentrics: Cross Domain Consent Sharing is not available.`
        return CookieConsent.Disabled;
    }
};
export { checkConsent, CookieConsent };
